import { clearAuth, getAccessToken } from '@/lib/authToken'

/**
 * Request headers with the bearer token attached when signed in (pattern from
 * cgt-frontend src/lib/authFetch.ts). An explicit header in `extra` wins.
 */
export function authHeaders(extra?: HeadersInit): HeadersInit {
  const token = getAccessToken()
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  }
}

/**
 * On a 401 the session is dead: clear it and bounce to the login screen. Call
 * before throwing so a stale token can't trap the user. Already on /login →
 * no navigation (a wrong credential there is a 401 too).
 */
export function handleUnauthorized(status: number): void {
  if (status !== 401) return
  clearAuth()
  if (window.location.pathname !== '/login') {
    window.location.assign('/login')
  }
}
